import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import FormTextField from '../../legacyForm/FormTextField';

const validate = (fieldValue, _, props, name) => {
  const fieldDefinition = props.budget.applicationTemplate.form.filter(f => f.type === 'description' || f.type === 'text')[parseInt(name.replace('].value', '').replace('form[', ''))];

  if (!fieldValue) {
    if (fieldDefinition.isOptional) return undefined;
    else return 'Pole jest wymagane';
  }
  const lengthLimit = fieldDefinition.constraints.maxLength != null
    ? fieldDefinition.constraints.maxLength
    : fieldDefinition.constraints.maxLengthLimit;

  if (fieldValue.length > lengthLimit)
    return `Długość pola nie może być większa niż ${lengthLimit} znaki(ów). Wprowadzono ${fieldValue.length} znaki(ów).`;
  return undefined;
};

const ApplicationFormTextField = ({ field, index, submissionIndex, readonly }) => (
  <div className="box">
    <div className="col-sm-12">
      <h3>{index + 1}. {field.title}</h3>
      <p>{field.description}</p>
      <div>
        <Field
          name={`form[${submissionIndex}].value`}
          component={FormTextField}
          fullWidth
          validate={validate}
          helperText={field.constraints.maxLength ? `Długość pola nie może być większa niż ${field.constraints.maxLength} znaki(ów).` : undefined}
          multiline
          rows={4}
          inputProps={{ 'aria-label': field.title }}
          disabled={readonly}
        />
      </div>
    </div>
  </div>
);

ApplicationFormTextField.propTypes = {
  field: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  submissionIndex: PropTypes.number.isRequired,
  readonly: PropTypes.bool,
};

export default ApplicationFormTextField;



// WEBPACK FOOTER //
// ./src/components/budget/applicationForm/ApplicationFormTextField.js